module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[45]532.ab3a024.woff2";